import classNames from 'classnames';

import styles from './CircleLoader.module.scss';

type TCircleLoaderProps = {
  size?: number;
  className?: string;
};

export function CircleLoader({
  size,
  className,
}: TCircleLoaderProps): JSX.Element {
  return (
    <div
      className={classNames(styles.loader, className)}
      style={size ? { height: size, width: size } : undefined}
    />
  );
}
